import { useEffect, useRef } from 'react';

export function usePrevious<T>(value: T, initialValue?: T) {
  const ref = useRef(initialValue);
  useEffect(() => {
    ref.current = value as any;
  }, [value]);
  return ref.current as T;
}
